module.exports = __webpack_public_path__ + "static/kb-new-3019d0eac496bfd27631f546aca0837c.png";